import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  cartItemQtyUpdateUrl,
  cartUrl,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "../../utils/constant";
import { formatPrice, getAuthToken } from "../../utils/common";
import { AppContext } from "../../store";
import Loading from "../common/Loading";
import {
  getAllCartItemIds,
  getBundleCartItemIds,
  gotoPdp,
} from "../../utils/activityHelper";
import { getSelectedSTObj } from "../../utils/addressUtils";
import { Bundle } from "src/types/global";
import defaultProductPic from "./../../images/default-brand.jpg";
import SCIcon from "Components/common/SCIcon";
import { Checkbox, message, Tooltip } from "antd";
import Counter from "Components/activity/Counter";
import Limitations from "Components/common/Limitation";

const BundleSection: React.FC<any> = (props: any) => {
  
  const { activityId, loadingCart, activityDetail, setAllChecked, onBundleQtyChange } =
    props;
  const [loading, setLoading] = useState<boolean>(true);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const {
    loginState,
    cartData,
    setCartData,
    activityPermissionMeta,
    refreshCart,
    refreshCartData,
    checkedCartItems,
    setCheckedCartItems,
  } = useContext(AppContext);
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );

  useEffect(() => {
    console.log("BundleSection rendered");
    if (loginState.status !== "login") return;
    setLoading(true);
    const selectedST = getSelectedSTObj(loginState);
    let cartIds: any[] = []
    if (activityDetail.activityBasicType === "bundle_promotion") {
      cartIds = getBundleCartItemIds(Array.from(checkedCartItems), cartData, true)
    }
    let reqBody = {
      activityId: activityId,
      shipTo: selectedST?.accountNumber,
      selectAll: firstLoad,
      cartIds,
    };
    console.log("refreshCartData reqBody", reqBody);
    axios(cartUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: reqBody,
    })
      .then((res) => {
        const respData = res.data;
        console.log("cart data", respData);
        console.log("firstLoad", firstLoad);
        if (respData.status === "success") {
          setCartData(respData.data);
          const win:any = window
          if (win.DPCache) {
            win.DPCache.checkedCartIds = null
          }
          const ids = getAllCartItemIds(respData.data, activityDetail.activityBasicType);
          console.log("ids", ids);
          if (firstLoad) {
            setFirstLoad(false);
            console.log("firstload cartdata");
            setCheckedCartItems(new Set(ids));
          }
          if (respData.data?.status === "bundle_product_changed") {
            onBundleQtyChange && onBundleQtyChange();
          }
        } else if (respData.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
          message.warning(activityNoPermissionLabel);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [loginState, activityId, refreshCart]);

  useEffect(() => {
    const ids = getAllCartItemIds(cartData, activityDetail.activityBasicType);
    if (ids.length === checkedCartItems.size) {
      console.log("checkedCartItems", "all checked");
      setAllChecked(true);
    } else {
      console.log("checkedCartItems", "not all checked");
      setAllChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, checkedCartItems]);
  const bundleList: any[] = cartData?.activity?.productGroup;

  return (
    <div className="cartWrapper cartBundlesWrapper">
      {(loading || loadingCart) && <Loading overCart={true} />}
      {bundleList?.map((bundleItem: any, index: number) => {
        return (
          <BundleItem
            checkedCartItems={checkedCartItems}
            setCheckedCartItems={setCheckedCartItems}
            key={bundleItem.tieredRule.id}
            cartData={cartData}
            bundleItem={bundleItem}
            setLoadingCart={setLoading}
            loginState={loginState}
            activityDetail={activityDetail}
            refreshCartData={refreshCartData}
            {...props}
          ></BundleItem>
        );
      })}
    </div>
  );
};

const BundleItem: React.FC<{
  bundle: Bundle;
  loginState: any;
}> = (props: any) => {
  const [resetCount, setResetCount] = React.useState(0);
  const {
    bundleItem,
    loginState,
    checkedCartItems,
    setCheckedCartItems,
    refreshCartData,
    setLoadingCart,
  } = props;
  const { cartItems, tieredRule } = bundleItem;
  const handleCartItemQtyChange = (newQty: number) => {
    console.log("newQty", newQty);
    if (newQty ===  bundleItem.bundleQuantity) return;
    setLoadingCart(true);
    axios(cartItemQtyUpdateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: {
        id: tieredRule.id,
        quantity: newQty,
        activityId: tieredRule.activityId
      },
    }).then((res) => {
      const respData = res.data;
      if (respData.status === "success") {
        console.log("cart item qty updated");
        refreshCartData();
        return;
      }
      if (respData.status === "inventory_not_enough") {
        message.warning(
          React.createElement("div", {
            style: {
              whiteSpace: "pre-line",
            },
          }, respData.message || "该货号库存不足，暂时无法加入购物车")
        );
        refreshCartData();
        setResetCount((pre) => pre + 1);
        return;
      }
      message.error('更新失败');
      setResetCount((pre) => pre + 1);
      refreshCartData();
    });
  };
  //console.log("bundleItem", bundleItem);
  return (
    <div className="cartTabWrapper cartBundleWrapper">
      <div className="sectionWrapper">
        <div className="checkboxWrapper">
          <Checkbox
            checked={checkedCartItems.has(tieredRule.id)}
            onChange={(e) => {
              console.log("checkbox changed", tieredRule.id, checkedCartItems);
              const checked = e.target.checked;
              if (checked) {
                checkedCartItems.add(tieredRule.id);
                setCheckedCartItems(new Set(checkedCartItems));
              } else {
                checkedCartItems.delete(tieredRule.id);
                setCheckedCartItems(new Set(checkedCartItems));
              }
              refreshCartData();
            }}
          ></Checkbox>
        </div>
        <div className="sectionHead">
          <div className="title"
          style={{
            fontSize: "16px",
            whiteSpace: "normal",
          }}
          dangerouslySetInnerHTML={{
            __html: tieredRule?.tieredName,
          }}
          ></div>
        </div>
        <div
          className={
            bundleItem?.matchRule ? "sectionDesc" : "sectionDesc highlight"
          }
        >
          {tieredRule?.tieredDescription}
        </div>
      </div>
      <div className="cartItems">
        {cartItems?.map((cartItem: any) => {
          const { product } = cartItem;
          if (!product) return null;
          return (
            <div className="cartItemWrapper">
              <div className="imgWrapper">
                <div className="productImg">
                  <img
                    alt=""
                    src={product.productPic || defaultProductPic}
                    onClick={() => {
                      gotoPdp(product, loginState, "Shopping_Cart");
                    }}
                  ></img>
                </div>
                <div className="shipIconWrapper">
                  {product.deliveryChannel === "SC" && <SCIcon />}
                </div>
              </div>
              <div className="descWrapper">
                <Tooltip
                  title={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: product.productName,
                      }}
                    ></span>
                  }
                  trigger={"hover"}
                >
                  <div
                    className={product.pdpViewable ? "line1 linkable" : "line1"}
                    onClick={() => {
                      console.log("product card clicked");
                      gotoPdp(product, loginState, "Shopping_Cart");
                    }}
                    dangerouslySetInnerHTML={{ __html: product.productName }}
                  ></div>
                </Tooltip>
                <div className="line">
                  <label>货号:</label>
                  <span>{product.sku}</span>
                </div>
                <div className="line">
                  <label>规格:</label>
                  <span>{product.productSize}</span>
                </div>
              </div>
              <div className="sideWrapper priceWrapper">
                <div>X {product.componentQuantity}</div>
                <div className="priceItem lightText lineThrough">
                  {formatPrice(product.listPrice)}
                </div>
                <div className="priceItem primaryText">
                  {formatPrice(product.finalPrice || product.promoPrice)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="cartBundleFooter">
        <div>
          <div>
            <span>套装价</span><span style={{paddingLeft: "4px", fontSize: "16px"}}>{formatPrice(tieredRule.bundleTotal)}</span>
          </div>
          <div
            style={{
              fontSize: "12px",
              paddingTop: "4px",
              color: "#e71316",
            }}
          >
            <Limitations tieredRule={tieredRule} comma={true}/>
          </div>
        </div>
        <div>
          <Counter
            product={{
              shoppingQty: bundleItem.bundleQuantity,
              min: tieredRule.minBundle,
              max: tieredRule.maxBundle,
            }}
            bundle={bundleItem}
            login={true}
            type={"bundle"}
            value={bundleItem.bundleQuantity}
            onChange={handleCartItemQtyChange}
            resetCount={resetCount}
          />
        </div>
      </div>
    </div>
  );
};

export default BundleSection;
